import { getShouldReplace } from 'src/utils//getShouldReplace';
import { useTrackIncomingBonusTransaction as useTrackIncomingBonusTransactionOriginal } from 'react-easyrocket';
import { useModalContext } from 'src/hooks/useModalContext';
import { useBonusModalData } from 'src/components/Modal/BonusModal/hooks/useBonusModalData';

export function useTrackIncomingBonusTransaction() {
  const { openModal } = useModalContext();
  const getBonusInfo = useBonusModalData();

  useTrackIncomingBonusTransactionOriginal({
    openBonusModal: async (bonusTransaction) => {
      const bonusData = await getBonusInfo(bonusTransaction.id);
      if (!bonusData) return;
      openModal('BONUS', {
        props: {
          bonusData
        },
        replace: getShouldReplace()
      });
    }
  });
}
